import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import OfferLetterApplicantList from "./OfferLetterApplicantList";
import { observer } from "mobx-react-lite";

const OfferLetterBody = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const status = location.state?.status || "declined";

  return (
    <div className="flex flex-col ">
      <div className="flex items-end">
        <div className="flex-1 flex justify-start">
          <LeftOutlined
            onClick={() => navigate(`/recruitment`)}
            className="cursor-pointer inline-flex items-center justify-center p-2 rounded-full transition-all duration-200 hover:border hover:border-gray-300 hover:shadow-md"
            style={{ fontSize: "35px" }}
          />
        </div>

        <h2 className="text-3xl font-bold text-center p-0 m-0 uppercase">LIST OF {status} APPLICANT</h2>

        <div className="flex-1" />
      </div>
      <div className="my-9 mx-6">
        <OfferLetterApplicantList />
      </div>
    </div>
  );
};

export default observer(OfferLetterBody);
